import { useTranslation } from "react-i18next";
import { PermissionsGate } from "../../../../../common/components/PermissionsGate";
import { COMPANY_ROUTES, PERMISSIONS } from "../../../../../common/constants";
import {
    PRODUCTS,
    PRODUCT_MODULES,
} from "../../../../../common/constants/products.constants";
import {
    IconEnergySettings,
    IconIntegration,
    IconLocations,
    IconUsers,
} from "../../Icons";
import { NavigationButton } from "../NavigationButton";

interface CompanyControlProps {
    companyId?: string;
}

const CompanyControls = (props: CompanyControlProps) => {
    const { companyId } = props;

    const { t } = useTranslation("common");

    const energyMenuItems = [
        {
            id: "company-controls-energy-general-item",
            label: t("general"),
            href: {
                pathname: COMPANY_ROUTES.ENERGY.GENERAL,
                query: {
                    companyId,
                },
            },
        },
        {
            id: "company-controls-energy-rulesets-item",
            label: t("rulesets"),
            href: {
                pathname: COMPANY_ROUTES.ENERGY.RULESETS,
                query: {
                    companyId,
                },
            },
        },
    ];

    return (
        <div className="flex items-center justify-center flex-col gap-4 mt-2 md:mt-8 [&>button>svg]:h-[2.15rem] [&>button>.p-button-icon]:h-[2.15rem]">
            <PermissionsGate
                permissions={[PERMISSIONS.COMPANY.READ]}
                checkAnyLocation
            >
                <NavigationButton
                    href={{
                        pathname: COMPANY_ROUTES.LOCATIONS,
                        query: {
                            companyId,
                        },
                    }}
                    label={t("locationSettings")}
                    icon={<IconLocations />}
                    className="[&>svg]:ml-4"
                />
            </PermissionsGate>
            <PermissionsGate
                permissions={[PERMISSIONS.ENERGY_SETTINGS.READ]}
                checkAnyLocation
                productsToCheck={[
                    {
                        id: PRODUCTS.BETTER_ENERGY,
                        modules: [{ id: PRODUCT_MODULES.BETTER_CONTROL }],
                    },
                ]}
            >
                <NavigationButton
                    label={t("energySettings")}
                    icon={<IconEnergySettings />}
                    className={"[&>svg]:ml-3"}
                    menuItems={energyMenuItems}
                />
            </PermissionsGate>
            <PermissionsGate
                permissions={[PERMISSIONS.USER.READ]}
                checkAnyLocation
            >
                <NavigationButton
                    href={{
                        pathname: COMPANY_ROUTES.USERS,
                        query: {
                            companyId,
                        },
                    }}
                    label={t("users")}
                    icon={<IconUsers />}
                />
            </PermissionsGate>
            <PermissionsGate
                permissions={[PERMISSIONS.INTEGRATION.READ]}
                checkAnyLocation
            >
                <NavigationButton
                    href={{
                        pathname: COMPANY_ROUTES.INTEGRATION,
                        query: {
                            companyId,
                        },
                    }}
                    label={t("integration")}
                    icon={<IconIntegration />}
                    className="[&>svg]:mb-0"
                />
            </PermissionsGate>
        </div>
    );
};

export default CompanyControls;
